import { useMediaQuery, useTheme } from '@material-ui/core'
import { Pagination } from '@material-ui/lab'

import { Tenant } from '../../types/tenants'
import TenantTable from './TenantTable'
import useStyles from './styles/TenantListDesktop.styles'

export interface TenantListProps {
  refetch: () => void
  filteredTenants: Tenant[]
  page: number
  perPage: number
  loading: boolean
  setPage: (value: number) => void
  numberOfPages: number
}
const TenantListDesktop: React.FC<TenantListProps> = ({
  refetch,
  filteredTenants,
  page,
  perPage,
  loading,
  numberOfPages,
  setPage
}) => {
  const theme = useTheme()
  const classes = useStyles()

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div>
      <TenantTable
        refetch={refetch}
        tenants={filteredTenants.slice((page - 1) * perPage, page * perPage)}
        loading={loading}
      />
      <div className={classes.paginationContainer}>
        <Pagination
          count={numberOfPages}
          color="primary"
          size={isSmallScreen ? 'small' : 'medium'}
          page={page}
          onChange={(_, value) => setPage(value)}
        />
      </div>
    </div>
  )
}
export default TenantListDesktop
